
import { Component, Prop, Vue } from 'vue-property-decorator';
import IconChip from '@/core/components/IconChip.vue';
import withdrawIconSVG from '@/assets/images/withdrawIcon.svg';
import { LoanProjectionEducationalInfo } from '@/loan/types/loan-projection-educational-info';
import { UtilHelper } from '@/util/helper';
import FlipCard from '@/core/components/FlipCard.vue';
import { LoanDetails } from '@/loan/types/loan-details';
import StatusBadge from '@/core/components/StatusBadge.vue';
import { namespace } from 'vuex-class';
import SuggestedAutopay from '@/loan/pages/LoanSummary/components/SuggestedAutopay.vue';
import LoanOverdueCard from '@/loan/components/LoanPaymentStatusCards/LoanOverdueCard.vue';
import PaymentAmountWidget from '@/core/components/PaymentAmountWidget.vue';
import { MONTH_MAP } from '@/util/constants/month-map';
import { LoanDetailsPeriod } from '@/loan/types/loan-details-period';
import moment from 'moment';

const loanNamespace = namespace('loan');

@Component({
	components: {
		IconChip,
		FlipCard,
		StatusBadge,
		SuggestedAutopay,
		LoanOverdueCard,
		PaymentAmountWidget,
	},
})
export default class Delinquent extends Vue {
	public formatDollar = UtilHelper.formatDollar;

	@Prop({ required: true })
	public info!: LoanProjectionEducationalInfo;

	@Prop({ required: true })
	public isAutopayOn!: boolean;

	@loanNamespace.Getter('autopayPaymentFrequencyText')
	public autopayPaymentFrequencyText!: string;

	@loanNamespace.Getter('outstandingFees')
	public outstandingFees!: number;

	@loanNamespace.Getter('autopayTotalAmount')
	public autopayTotalAmount!: number;

	@loanNamespace.Getter('currentPeriod')
	public currentPeriod!: LoanDetailsPeriod;

	@Prop({ required: true })
	public loanDetails!: LoanDetails;

	@Prop({ required: true })
	public loanId!: string;

	public icon = withdrawIconSVG;

	flipped: boolean = false;

	public formatDate = (date: string) => moment(date).format('MM/DD/YYYY');

	get overdueAmount(): string {
		return this.loanDetails?.general?.installmentPastDue ?? String(0);
	}

	get daysOverdue(): number {
		return this.loanDetails?.general?.delinquentDays ?? 0;
	}

	get paymentDue(): string {
		return (
			Number(this.loanDetails?.general?.paymentDueAmount) + Number(this.loanDetails?.general?.installmentPastDue)
		).toString();
	}

	get totalDue(): string {
		return (
			Number(this.loanDetails?.general?.paymentDueAmount) + Number(this.loanDetails?.general?.totalDueAmount)
		).toString();
	}

	get dueDate(): string {
		const date = new Date(this.loanDetails?.general?.paymentDueDate);
		const dayOfMonth = date.getDate();
		const monthNum = date.getMonth() + 1;
		const month = MONTH_MAP.get(monthNum);

		return `${month} ${dayOfMonth}`;
	}

	get paymentScheduleEndDatePlusGraceTime(): string {
		if (this.loanDetails?.general?.gracePeriod) {
			const momentedDate = moment(this.currentPeriod.paymentScheduleEndDate, 'YYYY-MM-DD');

			return momentedDate.add(this.loanDetails?.general?.gracePeriod, 'days').toString();
		}
		return this.currentPeriod.paymentScheduleEndDate;
	}
}
